import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../../Config";
import { useNavigate } from "react-router-dom";
import "./BetterTable.css";
import {
  Layout,
  Button,
  Typography,
  Select,
  Card,
  Avatar,
  Space,
  Tag,
  Popconfirm,
  Table
} from "antd";

import {
  EyeOutlined,
  EditOutlined,
  DeleteOutlined,
  MenuOutlined
} from "@ant-design/icons";
import Sidebar from "../../../Components/Sidebar";
import { Content, Header } from "antd/es/layout/layout";

const { Option } = Select;
const { Text } = Typography;

const ViewAllPages = () => {
  const [asanas, setAsanas] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [collapsed, setCollapsed] = useState(false);

  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const [selectedPage, setSelectedPage] = useState("");

  const navigate = useNavigate();

  const pageOptions = [
    { label: "yoga", value: "yoga" },
    { label: "Breathe Technique", value: "breathe-technique" },
    { label: "Warmup", value: "warmup" },
    { label: "Alternate Asanas", value: "alternate-asanas" },
    { label: "Do or Don’ts", value: "do-or-donts" },
    { label: "How to Make Variation", value: "how-to-make-variation" },
    { label: "Mudra", value: "mudra" },
    { label: "Tool", value: "tool" },
    { label: "Time", value: "time" },
    { label: "Meditations", value: "meditations" },
    { label: "Shatkarmas", value: "shatkarmas" },
  ];

  const fetchAllPages = async () => {
    try {
      const token = sessionStorage.getItem("token");

      const res = await axios.get(`${BASE_URL}/allpages`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = res.data.data || [];
      setAsanas(data);
      setFiltered(data);
      setLoading(false);
    } catch (error) {
      console.error("Fetch failed:", error);
      setLoading(false);
    }
  };

  const fetchFilteredPages = async (pageName) => {
    try {
      const token = sessionStorage.getItem("token");

      const res = await axios.get(`${BASE_URL}/allpages?page=${pageName}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setFiltered(res.data.data || []);
    } catch (error) {
      console.error("Filter fetch failed:", error);
    }
  };

  // Responsive sidebar
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  useEffect(() => {
    fetchAllPages();
  }, []);

  const MobileCard = ({ item }) => {
    return (
      <Card
        style={{
          marginBottom: 16,
          borderRadius: 16,
        }}
        bodyStyle={{ padding: 16 }}
      >
        {/* Top Section */}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Space align="center">

            <Avatar
              size={50}
              style={{
                backgroundColor: "#1677ff",
                fontWeight: "bold"
              }}
            >
              {item.page?.charAt(0).toUpperCase()}
            </Avatar>

            <div>

              <div
                style={{
                  fontWeight: 600,
                  fontSize: 16,
                }}
              >
                {item.page}
              </div>

              <div
                style={{
                  color: "#888",
                  fontSize: 13,
                }}
              >
                Created:
                {" "}
                {new Date(item.createdAt).toLocaleDateString()}
              </div>

            </div>

          </Space>

          <Tag color="processing">
            Page
          </Tag>

        </div>


        {/* Bottom Actions */}

        <div
          style={{
            marginTop: 16,
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
          }}
        >

          <Button
            icon={<EyeOutlined />}
            shape="round"
            onClick={() =>
              navigate(`/allpages/view/${item._id}`)
            }
          />

          <Button
            icon={<EditOutlined />}
            shape="round"
            onClick={() =>
              navigate(`/allpages/edit/${item._id}`)
            }
          />

          <Popconfirm
            title="Delete page?"
            onConfirm={() =>
              handleDelete(item._id)
            }
          >

            <Button
              danger
              shape="round"
              icon={<DeleteOutlined />}
            />

          </Popconfirm>

        </div>

      </Card>
    );
  };

  useEffect(() => {
    if (selectedPage !== "") return; // ignore search when filtered

    const filteredData = asanas.filter((item) =>
      item?.page?.toLowerCase().includes(search.toLowerCase())
    );
    setFiltered(filteredData);
  }, [search, asanas, selectedPage]);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete?")) return;

    try {
      const token = sessionStorage.getItem("token");

      await axios.delete(`${BASE_URL}/allpages/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Deleted successfully!");
      fetchAllPages();
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete");
    }
  };

  const columns = [
    {
      title: "#",
      render: (_, __, index) => index + 1,
    },

    {
      title: "Page",
      dataIndex: "page",
    },

    {
      title: "Created",
      dataIndex: "createdAt",
      render: (date) =>
        new Date(date).toLocaleString(),
    },

    {
      title: "Actions",
      render: (_, record) => (

        <Space>

          <Button
            icon={<EyeOutlined />}
            onClick={() =>
              navigate(`/allpages/view/${record._id}`)
            }
          />

          <Button
            icon={<EditOutlined />}
            onClick={() =>
              navigate(`/allpages/edit/${record._id}`)
            }
          />
          <Popconfirm
            title="Delete?"
            onConfirm={() =>
              handleDelete(record._id)
            }
          >
            <Button
              danger
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        </Space>

      ),
    },
  ];

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}
        collapsedWidth="0"
        role="admin"
      />

      <Layout
        className="main-layout"
        style={{
          marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
          transition: "0.3s",
          padding: isMobile ? 10 : 20,
        }}
      >
        <Header
          className="MainHeader"
        >
          {isMobile && (
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setMobileOpen(true)}
              style={{ fontSize: 18, marginRight: 12 }}
            />
          )}
          <div style={{ flex: 1 }}>
            <Text style={{ fontSize: 20, fontWeight: "bold" }}>All Pages</Text>
          </div>
        </Header>

        <Content style={{ padding: "20px" }}>
          <div className="better-table-page">
            {/* FILTER DROPDOWN */}
            <div
              style={{
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <h3>Filter by page:</h3>
              <Select
                placeholder="Select Page"
                value={selectedPage}
                allowClear
                onChange={(value) => {
                  setSelectedPage(value || "");

                  if (!value) {
                    setFiltered(asanas); // reset filter
                  } else {
                    fetchFilteredPages(value); // value is backend enum
                  }
                }}
                style={{ width: 300 }}
              >
                {pageOptions.map((page) => (
                  <Option key={page.value} value={page.value}>
                    {page.label}
                  </Option>
                ))}
              </Select>
            </div>

            <div className="better-table-wrapper">
              {
                isMobile ? (
                  filtered.map((item, index) => (
                    <MobileCard
                      key={item._id}
                      item={item}
                      index={index}
                    />
                  ))
                ) : (
                  <Table
                    columns={columns}
                    dataSource={filtered}
                    rowKey="_id"
                    loading={loading}
                  />
                )
              }
            </div>
          </div>
        </Content>
      </Layout>
    </Layout >
  );
};

export default ViewAllPages;
